const MS_PER_SECOND = 1000;
const MS_PER_MINUTE = 60 * MS_PER_SECOND;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;

export const toMsSinceMidnight = (date: Date): number =>
  date.getHours() * MS_PER_HOUR +
  date.getMinutes() * MS_PER_MINUTE +
  date.getSeconds() * MS_PER_SECOND +
  date.getMilliseconds();

// Adding to midnight's epoch would land 9h at 10:00 on a spring-forward day.
export const applyMsSinceMidnight = (
  date: Date,
  msSinceMidnight: number,
): Date =>
  new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    0,
    0,
    0,
    msSinceMidnight,
  );
